__webpack_require__.p = "/mgl-memo/";